import { render, staticRenderFns } from "./AdminTrailerDetails.vue?vue&type=template&id=79774111&scoped=true"
import script from "./AdminTrailerDetails.vue?vue&type=script&lang=js"
export * from "./AdminTrailerDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminTrailerDetails.vue?vue&type=style&index=0&id=79774111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79774111",
  null
  
)

export default component.exports